import Cookies from 'js-cookie';
import { SECURE_COOKIE } from '../../constants/joshConstants';

const SESSION_EXP = 30 * 1000;
const in30Minutes = 1 / 48;
const in30MinMill = 30 * 60 * 1000;

class UserSession {
  constructor(unique_id) {
    // console.log("USerID constructor", unique_id)
    this.sessionId = this.startSession(unique_id);
  }

  startSession = (unique_id) => {
    // console.log("USerID", unique_id)
    let josh_sessionId = Cookies.get('josh_sessionId');
    let epoch = Date.now();
    if (!josh_sessionId) {
      josh_sessionId = `${unique_id}_${epoch}`;
      Cookies.set('josh_sessionId', josh_sessionId, { expires: in30Minutes, path: '/', secure: SECURE_COOKIE });
      // console.log("New User Session Init.", josh_sessionId)
    }
    return josh_sessionId;
  }

  getSessionId = () => {
    return this.sessionId;
  }

  getSessionStartTime = () => {
    let startTime = this.sessionId && this.sessionId.split('_')[1];
    startTime = startTime && Number.parseInt(startTime);
    return startTime;
  }

  getSessionDetails = () => {
    let details = {};
    details.sessionId = this.getSessionId();
    details.startTime = this.getSessionStartTime();
    return details;
  }

  endSession = (callback) => {
    let josh_sessionId = Cookies.get('josh_sessionId');
    if (josh_sessionId) {
      Cookies.remove('josh_sessionId', { path: '/' });
    }
    // return josh_sessionId;
    callback(this.sessionId);
    this.sessionId = null;
  }

  autoRepeatingSessions = (cb) => {
    const refreshSession = () => {
      // const session_id_ended = endSession();
      // const session_id_started = startSession();
      // Refresh session and call the cb()
      cb();
    }

    setInterval(refreshSession, in30MinMill);
  }
}

export default UserSession;